import React, { useState, useEffect } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import firebase from "./firebase/firebase";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

import { Grid } from "@material-ui/core";

import styled from 'styled-components';


const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    fontFamily: "Oswald",
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    }
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 200
    }
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  bar: {
    backgroundColor: "#34495E "
  },
  button: {
    margin: theme.spacing(1),
    color: "#FFF",
    background: "transparent"
  },
  paper: {
    padding: theme.spacing(3, 2)
  },
  weekly: {
    marginTop: 5,
    width: "65%",
    padding: 0
  },
  trending: {
    width: "30%",
    marginRight: 0
  },
  backColor: {
    background:"#FFF",
    backgroundSize:"cover",
    display:"flex",
    paddingBottom:10
  },
  blocks: {
    margin: 5,
    //display: "inline-block",
    alignItems: "center",
    alignContent: "center"
  },
  songprev: {
    height: "150px",
    width: "150px",
    
  },
  songDetails: {
    textAlign:"start",
    fontSize: 14,
  }
}));

const StyledButton = styled.button`
  color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 16px;
  margin: 5px 10px 0px;
  align:center;

	&:hover {
		background: none;
    color: yellow;
    cursor:pointer;
	}
`;

export default function Homepage(props) {
  const classes = useStyles();

  const [songs, setSongs] = useState([]);

  useEffect(() => {
    getSongs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSongs = () => {
    var allSongs = [];
    firebase
      .firestore()
      .collection("DownloadUrls")
      .limit(16)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          if (doc.exists) {
            allSongs.push(doc.data());
            var re = Object.values(allSongs);
            setSongs(re);
          }
        });
      })
      .catch(err => {
        console.log("error", err);
      });
  };

  return (
    <React.Fragment>
        <div className={classes.backColor}>
          <Grid container justify="center">
            {songs.map(item => (
              <Grid item  className={classes.blocks} key={item.Url}>
                <Paper elevation={20} className={classes.songprev} style={{
                      background:`url(${item.Url}) no-repeat`,
                      backgroundSize:"cover"
                    }}>
                  <StyledButton
                      variant="outlined"
                      onClick={() => {
                        window.open(item.Song);
                      }}
                    >
                      Download
                    </StyledButton>
                </Paper>
                <Grid item xs={12} className={classes.songDetails}>
                    <span>
                      {item.Artist} <br/>
                      {item.SongName}
                    </span>
                  </Grid>
              </Grid>
            ))}
          </Grid>
        </div>
    </React.Fragment>
  );
}
